import axios from 'axios'
import FileDownload from 'js-file-download'
class Axios {
  constructor(baseURL, prefix = '') {
    // generate a new axios instance
    this.axios = axios.create({
      baseURL: `${baseURL}${prefix}`
    })
  }

  /**
   * https://stackoverflow.com/questions/25433258/what-is-the-x-request-id-http-header
   * When you're operating a webservice that is accessed by clients, it might be difficult to correlate requests (that a client can see) with server logs (that the server can see).
   *
   * The idea of the X-Request-ID is that a client can create some random ID and pass it to the server. The server then include that ID in every log statement that it creates. If a client receives an error it can include the ID in a bug report, allowing the server operator to look up the corresponding log statements (without having to rely on timestamps, IPs, etc).
   *
   * As this ID is generated (randomly) by the client it does not contain any sensitive information, and should thus not violate the user's privacy. As a unique ID is created per request it does also not help with tracking users.
   * @param {*} headers
   * @param {*} isExternalApi
   * @returns { headers, x-request-id?}
   */
  getHeaders(headers, isExternalApi) {
    if (isExternalApi) {
      return headers
    }

    return {
      ...headers
      // 'x-request-id': uuidv4(),
    }
  }

  async httpGet(
    url,
    headers = {},
    isExternalApi = false,
    options = {},
    withCredentials = true
  ) {
    return this.axios({
      method: 'get',
      url,
      headers: this.getHeaders(headers, isExternalApi),
      options,
      withCredentials
    })
  }

  async httpPatch(url, headers, data) {
    return this.axios({
      method: 'patch',
      url,
      headers: this.getHeaders(headers),
      data,
      withCredentials: true
    })
  }

  async httpPost(url, headers, data) {
    return this.axios({
      method: 'post',
      url,
      headers: this.getHeaders(headers),
      data,
      withCredentials: true
    })
  }

  // Allow the caller to define how long the timeout should be
  // especially for operations that can take a while
  async httpPostTimeout(url, headers, data, timeout) {
    return this.axios({
      method: 'post',
      url,
      headers: this.getHeaders(headers),
      data,
      withCredentials: true,
      timeout
    })
  }

  async httpPut(url, headers, data) {
    return this.axios({
      method: 'put',
      url,
      headers: this.getHeaders(headers),
      data,
      withCredentials: true
    })
  }

  async httpDelete(url, headers) {
    return this.axios({
      method: 'delete',
      url,
      headers: this.getHeaders(headers),
      withCredentials: true
    })
  }

  async httpDownload(url, filename) {
    return this.axios({
      method: 'get',
      url,
      responseType: 'blob',
      withCredentials: true
    }).then((response) => {
      FileDownload(response.data, filename)
    })
  }
}

export default Axios
